import { Lock } from "lucide-react";

const LEDGER_ROWS = [
  { label: "Business Name", value: "KAJE", mono: false, testId: "ledger-business-name" },
  { label: "Sole Trader / Owner", value: "Justin Kingaby", mono: false, testId: "ledger-owner" },
  { label: "Australian Business Number", value: "13 907 721 664", mono: true, testId: "ledger-abn" },
  {
    label: "Service Coverage",
    value: "Australia (with global expansion capability)",
    mono: false,
    testId: "ledger-coverage",
  },
  {
    label: "Nature of Business",
    value: "Custom Software & Mobile App Engineering",
    mono: false,
    testId: "ledger-nature",
  },
];

export const Verification = () => {
  return (
    <section
      id="verification"
      className="py-24 px-6 bg-slate-100 border-b border-slate-200"
      data-testid="verification-section"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 space-y-6">
          <span className="text-xs uppercase font-bold tracking-widest text-emerald-700 kaje-body">
            Official Ledger
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Business Standing &amp; Structure
          </h2>
          <p className="kaje-body text-sm text-slate-600 leading-relaxed">
            KAJE is registered as an Australian sole trader business entity operated directly by
            Justin Kingaby, providing custom software engineering services to domestic and
            international clients.
          </p>

          <div
            className="bg-white rounded-lg border border-slate-200 shadow-sm divide-y divide-slate-100 text-sm kaje-body"
            data-testid="entity-ledger"
          >
            {LEDGER_ROWS.map((row) => (
              <div key={row.label} className="px-5 py-3.5 flex justify-between items-center gap-4">
                <span className="text-slate-500 font-medium">{row.label}</span>
                <span
                  data-testid={row.testId}
                  className={`text-right text-slate-900 ${row.mono ? "font-bold kaje-mono" : "font-bold"}`}
                >
                  {row.value}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div
            className="bg-white rounded-lg border border-dashed border-slate-300 p-8 text-center kaje-body"
            data-testid="proof-placeholder-card"
          >
            <div className="w-12 h-12 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mx-auto mb-3">
              <Lock className="w-6 h-6" strokeWidth={1.5} />
            </div>
            <h3 className="font-bold text-slate-900 text-sm">
              Client Reviews &amp; Project Track Record
            </h3>
            <p className="text-xs text-slate-500 mt-2 max-w-xs mx-auto">
              Verified customer feedback and detailed app rollout records will be listed here
              following subsequent version deployments.
            </p>
            <span className="inline-block mt-4 text-[11px] kaje-mono text-emerald-700 bg-emerald-100/70 font-semibold px-3 py-1 rounded">
              Active Production Status
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
